import CheckIcon from '@mui/icons-material/Check';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import Contact from '../../../models/Contact';
import { StyledButton } from '../../styles/StyledButtons';
import { StyledHeading } from '../../styles/styles';

interface ContactInvitationSectionProps {
  contact: Contact;
  generatingToken: boolean;
  linkCopied: boolean;
  onGenerateToken: () => void;
  onRegenerateToken: () => void;
  onNavigateToEmail?: (contactId: string) => void;
  onCopyLink: () => void;
}

export const ContactInvitationSection: React.FC<ContactInvitationSectionProps> = ({
  contact,
  generatingToken,
  linkCopied,
  onGenerateToken,
  onRegenerateToken,
  onNavigateToEmail,
  onCopyLink,
}) => {
  const invitationExpired = contact.invitationExpired ?? false;

  return (
    <Box>
      <StyledHeading tone="tone1">Platform Administration</StyledHeading>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {contact.invitationLink ? (
          invitationExpired ? (
            <>
              <Typography color="error">Invitation expired</Typography>
              <StyledButton onClick={onRegenerateToken}>Regenerate Token</StyledButton>
            </>
          ) : (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" sx={{ flex: 1 }}>
                  Invitation link: {contact.invitationLink}
                </Typography>
                <Typography
                  component="span"
                  onClick={onCopyLink}
                  sx={{
                    cursor: 'pointer',
                    color: linkCopied ? 'green' : 'primary.main',
                    textDecoration: linkCopied ? 'none' : 'underline',
                    fontSize: '0.8rem',
                  }}
                >
                  {linkCopied ? <CheckIcon /> : 'Copy'}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Expires In {`${contact.invitationExpiredInDays} days`}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <StyledButton onClick={() => onNavigateToEmail?.(contact.id)}>
                  Generate Email
                </StyledButton>
                <StyledButton onClick={onRegenerateToken}>Regenerate Token</StyledButton>
              </Box>
            </>
          )
        ) : (
          <StyledButton onClick={onGenerateToken} disabled={generatingToken}>
            {generatingToken ? (
              <>
                Generate Invitation Link <CircularProgress size={16} sx={{ ml: 1 }} />
              </>
            ) : (
              'Generate Invitation Link'
            )}
          </StyledButton>
        )}
      </Box>
    </Box>
  );
};
